module.exports = __webpack_public_path__ + "static/media/mengduo5.fb2be908.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/mengduo/mengduo5.png
// module id = 196
// module chunks = 6